export const FormSwitch = ({_key,name,value,input,change}:any) => {
    return(
        <div className="form-check form-switch mb-3">
            <input className="form-check-input" type="checkbox" role="switch" onChange={change} name={input} id={`visibleCheck${_key}`} defaultChecked={value} />
            <label className="form-check-label" htmlFor={`visibleCheck${_key}`}>{name}</label>
        </div>
    )
}